<template>
  <div v-loading="loading" class="brand-statistic-info">
    <div class="title">{{ spanShow }}区域分品牌统计</div>
    <div class="content">
      <table>
        <tr class="table-header">
          <td>区域<sort-caret col="area" @change="doSort"></sort-caret></td>
          <td>宝马系<sort-caret col="bmwPureSell" @change="doSort"></sort-caret></td>
          <td>奔驰系<sort-caret col="benzPureSell" @change="doSort"></sort-caret></td>
          <td>捷豹路虎<sort-caret col="landroverPureSell" @change="doSort"></sort-caret></td>
          <td>奥迪大众<sort-caret col="audiPureSell" @change="doSort"></sort-caret></td>
          <!--<td>其他<sort-caret col="othersPureSell" @change="doSort"></sort-caret></td>-->
          <td>合计<sort-caret col="total" @change="doSort"></sort-caret></td>
        </tr>
        <template v-if="context && context.length">
          <tr v-for="row in context" :key="row.area">
            <td>{{ row.area }}</td>
            <td>{{ row['bmwPureSell'] | wanFmt }}&nbsp;/&nbsp;{{ row['bmwCount'] }}笔</td>
            <td>{{ row['benzPureSell'] | wanFmt }}&nbsp;/&nbsp;{{ row['benzCount'] }}笔</td>
            <td>{{ row['landroverPureSell'] | wanFmt }}&nbsp;/&nbsp;{{ row['landroverCount'] }}笔</td>
            <td>{{ row['audiPureSell'] | wanFmt }}&nbsp;/&nbsp;{{ row['audiCount'] }}笔</td>
            <!--<td>{{ row['othersPureSell'] | wanFmt }}&nbsp;/&nbsp;{{ row['othersCount'] }}笔</td>-->
            <td>
              {{ (row['bmwPureSell'] + row['benzPureSell'] + row['landroverPureSell'] + row['audiPureSell']) | wanFmt }}
              &nbsp;/&nbsp;{{ (row['bmwCount'] + row['benzCount'] + row['landroverCount'] + row['audiCount']) }}笔
            </td>
          </tr>
          <tr v-if="context.length > 1">
            <td>合计</td>
            <td>{{ context.reduce((p, c) => p + c['bmwPureSell'], 0) | wanFmt }}&nbsp;/&nbsp;{{ context.reduce((p, c) => p + c['bmwCount'], 0) }}笔</td>
            <td>{{ context.reduce((p, c) => p + c['benzPureSell'], 0) | wanFmt }}&nbsp;/&nbsp;{{ context.reduce((p, c) => p + c['benzCount'], 0) }}笔</td>
            <td>{{ context.reduce((p, c) => p + c['landroverPureSell'], 0) | wanFmt }}&nbsp;/&nbsp;{{ context.reduce((p, c) => p + c['landroverCount'], 0) }}笔</td>
            <td>{{ context.reduce((p, c) => p + c['audiPureSell'], 0) | wanFmt }}&nbsp;/&nbsp;{{ context.reduce((p, c) => p + c['audiCount'], 0) }}笔</td>
            <!-- <td>{{ context.reduce((p, c) => p + c['othersPureSell'], 0) | wanFmt }}&nbsp;/&nbsp;{{ context.reduce((p, c) => p + c['othersCount'], 0) }}笔</td> -->
            <td>
              {{ totalAmount | wanFmt }}
              &nbsp;/&nbsp;{{ totalCount }}笔
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="6" class="no-data">暂无数据</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>
<script>
import { loadMonthAreaBrand } from '../services'
import moment from 'moment'
import SortCaret from '@/components/SortCaret.vue'
export default {
  name: 'BrandStatisticInfo',
  components: { SortCaret },
  props: {
    spanType: {
      type: String,
      default () {
        return 'month'
      }
    },
    curMonth: {
      type: String,
      default () {
        return moment().format('YYYY-MM-01')
      }
    }
  },
  filters: {
    wanFmt (val) {
      if (val) {
        let numberStr = (+val / 10000).toFixed(2)
        if (numberStr.endsWith('.00')) {
          numberStr = numberStr.substring(0, numberStr.length - 3)
        }
        return numberStr + '万'
      } else {
        return val
      }
    }
  },
  data () {
    return {
      loading: true,
      context: []
    }
  },
  computed: {
    totalAmount () {
      return this.context.reduce((p, row) => p + row['bmwPureSell'] + row['benzPureSell'] + row['landroverPureSell'] + row['audiPureSell'], 0)
    },
    totalCount () {
      return this.context.reduce((p, row) => p + row['bmwCount'] + row['benzCount'] + row['landroverCount'] + row['audiCount'], 0)
    },
    spanShow () {
      return this.spanType === 'month' ? moment(this.curMonth).format('YYYY-MM') : moment(this.curMonth).format('YYYY-[Q]Q')
    },
    curSpanStart () {
      return moment(this.curMonth).format('YYYY-MM-01')
    },
    curSpanEnd () {
      return moment(this.curMonth).add(this.spanType === 'month' ? 1 : 3, 'months').format('YYYY-MM-01')
    }
  },
  watch: {
    area () {
      this.loadData()
    },
    spanShow () {
      this.loadData()
    }
  },
  methods: {
    doSort (sortConfig) {
      this.context = this.context.sort((a, b) => {
        if (sortConfig.col === 'area') {
          if (sortConfig.direct === 1) {
            return a.area.localeCompare(b.area)
          } else {
            return b.area.localeCompare(a.area)
          }
        }
        if (sortConfig.direct === 1) {
          return a[sortConfig.col] - b[sortConfig.col]
        } else {
          return b[sortConfig.col] - a[sortConfig.col]
        }
      })
    },
    loadData () {
      this.loading = true
      loadMonthAreaBrand(this.curSpanStart, this.curSpanEnd, this.area).then((resp) => {
        resp.forEach(row => {
          row.total = row.bmwPureSell + row.benzPureSell + row.landroverPureSell + row.audiPureSell // + row.othersPureSell
        })
        this.context = resp
      }).finally(() => {
        this.loading = false
      })
    }
  },
  beforeMount () {
    this.loadData()
  }
}
</script>
